export const dataTestIdFormat = (name: string, id: number) => {
  return `${name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}-${id}-input`;
};
